import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  type DismissNotificationParams,
  type DismissNotificationResponse,
  dismissNotificationMutation,
} from '@/api/customer/dismissNotificationMutation';
import { Logger } from '@/utils/logging';

import type { UseDismissNotificationMutationOptions } from './types';

export const useDismissNotificationMutation = ({
  customerId,
  onSuccess,
  onError,
}: UseDismissNotificationMutationOptions) => {
  const queryClient = useQueryClient();

  return useMutation<
    DismissNotificationResponse,
    Error,
    DismissNotificationParams
  >({
    ...dismissNotificationMutation(),
    onError: (error, variables, onMutateResult, context) => {
      Logger.error('Error dismissing notifications', { error, variables });
      onError?.(error, variables, onMutateResult, context);
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      onSuccess?.(data, variables, onMutateResult, context);
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [
          'customer',
          customerId,
          'notifications',
          'appointmentReview',
        ],
      });
    },
  });
};
